<template>
  <div>
    <div class="row menubar">
      <div style="float: right;">
      <button
        @click="
          currentPage = 0;
          scores = [];
          getAdminNps();
        "
      >
        <awesomeIcon icon="sync" />
      </button>
      </div>
      <div class="title">NPS</div>
      <inputDropdown
        :array="scoreFiltersOptions"
        v-model="selectedScoreFilter"
        style="float:right"
        :cb="dropdownCB"
        displayPrefix="Score: "
      />
      <inputDropdown
        :array="monthFiltersOptions"
        v-model="selectedMonthFilter"
        displayPrefix="Maand: "
        :cb="dropdownCB"
        style="float:right"
      />
      <inputDropdown
        :array="yearFiltersOptions"
        v-model="selectedYearFilter"
        displayPrefix="Jaar: "
        :cb="dropdownCB"
        style="float:right"
      />
      <inputDropdown
        :array="brandFiltersOptions"
        v-model="selectedBrandFilter"
        displayPrefix="Merk: "
        :cb="dropdownCB"
        style="float:right"
      />
    </div>

    <div class="card" v-if="scores.length > 0">
      <table>
        <thead class="table-legend">
          <tr>
            <th width="10%">Jaar</th>
            <th width="15%">Maand</th>
            <th>Datum</th>
            <th width="10%">Score</th>
            <th>Email</th>
            <th colspan=5 width="70">Merken</th>
          </tr>
        </thead>
        <tr
          v-for="(score, index) in slice(
            filteredScores,
            currentPage * resultsPerPage,
            (currentPage + 1) * resultsPerPage
          )"
          :key="index"
        >
          <td width="15%">{{score.year}}</td>
          <td width="15%">{{monthNames[score.month]}}</td>
          <td>{{(new Date(score.date)).toLocaleString()}}</td>
          <td width="10%">{{score.score}}</td>
          <td class="concat" :title="score.email">
            {{score.email}}
          </td>
          <td>{{score.vmvb ? 'V' : ''}}</td>
          <td>{{score.bvs ? 'B' : ''}}</td>
          <td>{{score.oxby ? 'O' : ''}}</td>
          <td>{{score.doelbeleggen ? 'D' : ''}}</td>
          <td>{{score.unknown || score.nobrand ? '?' : ''}}</td>
        </tr>
        <tr>
          <th colspan="3">
            Aantal: {{
              filteredScores.length
            }}
          </th>
          <th colspan="7">
            Gemiddelde: {{
              formatPrice(
                Number(sumBy(filteredScores, 'score') / filteredScores.length)
              )
            }}
          </th>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="filteredScores.length"
        :resultsPerPage="resultsPerPage"
      />
    </div>
    <div v-else class="loader" />
  </div>
</template>

<script>
import {
  slice, sumBy, filter, includes,
} from 'lodash-es';

export default {
  name: 'AdminNPS',
  data() {
    return {
      currentPage: 0,
      resultsPerPage: 20,
      monthNames: [
        'Alles',
        'Januari',
        'Februari',
        'Maart',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Augustus',
        'September',
        'Oktober',
        'November',
        'December',
      ],
      scores: [],
      users: [],
      selectedYearFilter: 'Alles',
      yearFiltersOptions: [
        {
          value: 'Alles',
        },
      ],
      selectedMonthFilter: 'Alles',
      monthFiltersOptions: [
        {
          value: 'Alles',
        },
      ],
      selectedBrandFilter: 'Alles',
      brandFiltersOptions: [
        {
          value: 'Alles',
        },
        {
          value: 'VMVB',
        },
        {
          value: 'BVS',
        },
        {
          value: 'Doelbeleggen',
        },
        {
          value: 'Oxby',
        },
        {
          value: '?',
        },
      ],
      selectedScoreFilter: 'Alles',
      scoreFiltersOptions: [
        {
          value: 'Alles',
        },
        {
          value: 'Promotor',
        },
        {
          value: 'Demoter',
        },
      ],
    };
  },
  created() {
    this.getAdminNps();
  },
  computed: {
    filteredScores() {
      return filter(
        filter(
          filter(
            filter(
              this.scores,
              this.brandFilter,
            ),
            this.monthFilter,
          ),
          this.yearFilter,
        ),
        this.scoreFilter,
      );
    },
  },
  methods: {
    slice,
    sumBy,
    dropdownCB() {
      this.currentPage = 0;
    },
    monthFilter(obj) {
      if (this.selectedMonthFilter !== 'Alles') {
        if (this.selectedMonthFilter === this.monthNames[obj.month]) {
          return true;
        }
        return false;
      }
      return true;
    },
    yearFilter(obj) {
      if (this.selectedYearFilter !== 'Alles') {
        if (this.selectedYearFilter === obj.year) {
          return true;
        }
        return false;
      }
      return true;
    },
    brandFilter(obj) {
      if (this.selectedBrandFilter !== 'Alles') {
        if (this.selectedBrandFilter === 'VMVB' && obj.vmvb) {
          return true;
        }
        if (this.selectedBrandFilter === 'BVS' && obj.bvs) {
          return true;
        }
        if (this.selectedBrandFilter === 'Oxby' && obj.oxby) {
          return true;
        }
        if (this.selectedBrandFilter === 'Doelbeleggen' && obj.doelbeleggen) {
          return true;
        }
        if (this.selectedBrandFilter === '?' && (obj.unknown || obj.nobrand)) {
          return true;
        }
        return false;
      }
      return true;
    },
    scoreFilter(obj) {
      if (this.selectedScoreFilter !== 'Alles') {
        if (this.selectedScoreFilter === 'Promotor') {
          if (obj.score >= 8) {
            return true;
          }
        } else if (this.selectedScoreFilter === 'Demoter') {
          if (obj.score <= 5) {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    getAdminNps() {
      this.sdk.getAdminNps((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            response.data[i].year = new Date(response.data[i].date).getFullYear();
            response.data[i].month = new Date(response.data[i].date).getMonth() + 1;

            if (
              !this.yearFiltersOptions.find(
                (obj) => obj.value === response.data[i].year,
              )
            ) {
              this.yearFiltersOptions.push({ value: response.data[i].year });
            }

            response.data[i].brands = `${response.data[i].brands}`.split(',');
            if (includes(response.data[i].brands, 'VMVB')) {
              response.data[i].vmvb = true;
            }
            if (includes(response.data[i].brands, 'BVS')) {
              response.data[i].bvs = true;
            }
            if (includes(response.data[i].brands, 'OXBY')) {
              response.data[i].oxby = true;
            }
            if (includes(response.data[i].brands, 'Doelbeleggen')) {
              response.data[i].doelbeleggen = true;
            }
            if (includes(response.data[i].brands, 'null')) {
              response.data[i].unknown = true;
            }
            if (
              !this.monthFiltersOptions.find(
                (obj) => obj.value === this.monthNames[response.data[i].month],
              )
            ) {
              this.monthFiltersOptions.push({ value: this.monthNames[response.data[i].month] });
            }
          }
          this.scores = response.data;
          this.monthFiltersOptions.sort(
            (a, b) => this.monthNames.indexOf(a.value) - this.monthNames.indexOf(b.value),
          );
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  table {
    table-layout:fixed;
  }
  .dropdown-wrapper {
    padding: 0;
  }
  .dropdown {
    border: none;
    float: right;
    padding-left: 10px;
    padding-right: 10px;
  }
  .dropdown-list {
    min-width: 300px;
  }
</style>
